import './App.css';
import { Route, Routes } from "react-router-dom";
import DbhaiHome from "./custom-components/DbhaiHome";
import SignIn from './auth-components/SignIn';
import UnAuthHome from './custom-components/UnAuthHome';

// import DownPage from 'custom-components/DownPage';

function App() {

   
  return (

    <Routes>
     
      <Route path="/Home" element={<DbhaiHome/>}/>
      <Route path="/" element={<UnAuthHome/>}/>
      <Route path="*" element={<SignIn/>}/>
      <Route path="/GetStarted" element={<SignIn/>}/>

      {/* When app is down.. */}
      {/* <Route path="/GetStarted" element={<DownPage/>}/>
      <Route path="*" element={<DownPage/>}/>
      <Route path="/" element={<DownPage/>}/> */}
      
    </Routes>

  );
}

export default App;
